import { BaseWebComponentView } from '../../../../framework/BaseWebComponentView';
import { GzTitleWebComponent } from '../../../../ui/gzTitle';
import { FormGroup } from '../../../../ui/gzForm/formGroup/form-group';
import { GzFormListWebComponent } from '../../../../ui/gzForm/formList';
import { CustomFieldsInformation } from '../types/CustomFieldsInformation';
import { RegexValidator } from '../../../../ui/gzForm/validators/regex.validator';
import { MaxLengthValidator } from '../../../../ui/gzForm/validators/max-length.validator';
import { CustomFieldsFormConstants } from '../CustomFieldsFormConstants';
import { GzTextWebComponent } from '../../../../ui/gzText';
import { FormListItem } from '../../../../ui/gzForm/formList/types/FormListItem';
import { CompanyEditingRight } from '../../types/CompanyEditingRight';
import {htmlEncode} from "../../../../utils/escape.utils";

export class CustomFieldsFormView extends BaseWebComponentView {
  public formGroup!: FormGroup;
  private customFieldsFormAvailability!: boolean;

  public dom: {
    $wrapper: HTMLElement;

    $customFieldsTitle: GzTitleWebComponent;
    $infoText: GzTextWebComponent;

    $customFieldsForm: GzFormListWebComponent;
  };

  getDomElements() {
    this.dom = {
      $wrapper: this.shadow.querySelector('#wrapper'),

      $customFieldsTitle: this.shadow.querySelector('#custom-fields-title'),
      $infoText: this.shadow.querySelector('#custom-fields-details-text'),

      $customFieldsForm: this.shadow.querySelector('#custom-fields-form'),
    };
  }

  setTranslatedStrings() {
    this.dom.$customFieldsTitle.innerText = this.dependencies.translateFn('Custom Fields');
    this.dom.$infoText.innerText = this.dependencies.translateFn(
      'Enter the values specific to this company for the defined custom fields. The fields appear as additional columns in the Monthly License Usage report.'
    );
  }

  public get isCustomFieldsFormAvailable(): boolean {
    return this.customFieldsFormAvailability;
  }

  buildSuccessView({
    customFieldsInformation,
    editingRight,
  }: {
    customFieldsInformation: CustomFieldsInformation;
    editingRight: CompanyEditingRight;
  }) {
    this.customFieldsFormAvailability = !!customFieldsInformation.customFieldsDefinitions.length;
    if (!this.customFieldsFormAvailability) {
      return;
    }

    this.setupCustomFieldsForm(customFieldsInformation);
    this.createFormGroup();
    this.setTranslatedStrings();

    this.setFormGroupToDisabled(editingRight);
  }

  buildErrorView(error: Error) {}

  public setFormGroupToDisabled(editingRight: CompanyEditingRight) {
    if (editingRight !== CompanyEditingRight.None) {
      return;
    }

    this.formGroup.setDisabled(true);
  }

  private createFormGroup() {
    this.formGroup = FormGroup.build({
      fields: this.dom.$customFieldsForm,
    });
  }

  private setupCustomFieldsForm(customFieldsInformation: CustomFieldsInformation) {
    this.dom.$customFieldsForm.Validators = [
      RegexValidator(
        CustomFieldsFormConstants.RegexValueForCustomFields,
        this.dependencies.translateFn('Special characters are not permitted')
      ),
      MaxLengthValidator(
        CustomFieldsFormConstants.MaxLengthValueForCustomFields,
        this.dependencies.translateFn('Maximum length permitted is {maxLength} characters', {
          maxLength: CustomFieldsFormConstants.MaxLengthValueForCustomFields,
        })
      ),
    ];

    for (const customFieldData of customFieldsInformation.customFieldsDefinitions) {
      const formListItem: FormListItem = {
        id: customFieldData._id,
        name: customFieldData.name,
        placeholder: htmlEncode(customFieldData.name),
      };

      if (customFieldData.name in customFieldsInformation.customFieldsValues) {
        formListItem.value = customFieldsInformation.customFieldsValues[customFieldData.name];
      }
      this.dom.$customFieldsForm.addFormListItem(formListItem);
    }
  }

  public discardFormChanges() {
    this.formGroup?.discardChanges();
  }
}
